import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    countToolsAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/tool/counts`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    storeToolAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/store`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateToolAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/tool/update/${payload.get("tool_id")}`, payload)
          .then((res) => {
            resolve(res.data.tool);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findToolsParamsAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/find-by-params`, payload)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deletePhotoToolAction(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/delete-photo`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findToolsParamsDashAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/search-dash`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    findToolsAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/find-tools`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteToolAction(Context, toolId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/tool/delete-tool/${toolId}`)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    desvinculeEmployeeTool(Context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/desvincule-employee`, payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    countVehiculesByCategory(){
      return new Promise((resolve, reject) => {
        axios
          .post(`/tool/count-by-category`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
